const searchAssignment = (state, action) => {
  switch (action.status) {
    case 'success':
      return {
        ...state,
        query: action.payload.query,
      };
    default:
      return state;
  }
};

export default searchAssignment;
